import { render, staticRenderFns } from "./ArtisanTreeSelect.vue?vue&type=template&id=00ca36f5"
import script from "./ArtisanTreeSelect.vue?vue&type=script&lang=js"
export * from "./ArtisanTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports